import { reviewableRequestsService } from '@api/reviewable_requests.service'
import { RecordFactory } from '@js/records/factory'
import { Paginator } from '@js/helpers/paginator'

const state = {
  withdrawals: new Paginator(RecordFactory.createWithdrawRecord.bind(RecordFactory))
}

const mutations = {
}

const actions = {
  async GET_WITHDRAWALS ({ state }, filters) {
    await reviewableRequestsService.loadWithdrawalsRequests(filters)
    state.withdrawals.attachInitLoader(() => reviewableRequestsService.loadWithdrawalsRequests(filters))
    return state.withdrawals.init()
  },

  async NEXT_WITHDRAWALS ({ state }, filters) {
    const records = state.withdrawals.next(filters)
    // restore loaders state
    state.withdrawals.attachInitLoader(() => reviewableRequestsService.loadWithdrawalsRequests(filters))
    return records
  }
}

const getters = {
  withdrawals: state => state.withdrawals
}

export default {
  actions,
  getters,
  mutations,
  state
}



// WEBPACK FOOTER //
// ./src/vuex/modules/withdrawals.module.js